import React from 'react';
import * as PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

function AppointmentStepper({ completedSteps, totalSteps }) {
  const { useHistory } = useAppContext();

  const history = useHistory();

  const getStepsContent = () => {
    const content = [];
    for (let i = 1; i < totalSteps; i++) {
      content.push(<li key={`step-${i}`} className={i <= completedSteps ? 'active' : ''} role="presentation">{i}</li>);
    }
    return content;
  };

  return (
    <div className="appointment-stepper">
      <a className="back-btn" href="#" aria-label="Previous page">
        <ArrowBackIcon />
        <span className="button-text" onClick={() => history.goBack()}>
          Previous page
        </span>
      </a>
      <div className="flex-steps">
        <ul>
          {getStepsContent()}
        </ul>
      </div>
    </div>
  );
}

AppointmentStepper.defaultProps = {
  backLink: '#',
  completedSteps: 0,
  totalSteps: 5,
};

AppointmentStepper.propTypes = {
  backLink: PropTypes.string,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
};

export default AppointmentStepper;
